import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Table, message, Checkbox } from 'antd';
import TableConfig from './TableConfig';
import TableTitle from './TableTitle';
import Preloader from '../../../../../components/preloader/Preloader';
import { PreloaderBox } from '../../../../../../../common/ui/Common';

const PAGE_SIZE = 50;

function DetailedReport({ settings, preloader }) {
  const [ReportParams, setReportParams] = useState();
  const [loading, setLoading] = useState(false);
  const [showWeight, setShowWeight] = useState(false);
  const [questionListData, setQuestionListData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: PAGE_SIZE, total: 0 });
  const { startDate, endDate } = settings;

  const fetchReportData = useCallback(async (page = 1, pageSize = PAGE_SIZE) => {
    setLoading(true);
    preloader();
    const token = window.localStorage.getItem('token');
    const offset = (page - 1) * pageSize;

    try {
      const res = await axios.get('/api/reports/qualityDetailedReport', {
        params: {
          token,
          startDate,
          endDate,
          limit: pageSize,
          offset,
        },
      });

      const { data: responseData } = res;

      if (!responseData.success) {
        message.error(responseData.error || 'Ошибка загрузки отчёта');
        setReportParams((prev) => prev || null);
        preloader();
        setLoading(false);
        return;
      }

      const { data: items, totalCount, questionList } = responseData;
      const qListData = questionList?.data || [];
      setQuestionListData(qListData);

      const params = {
        filters: { main: { startDate, endDate } },
        items: items || [],
        TableConfig: TableConfig(qListData, showWeight),
        TebleType: 'DetailedReport',
      };

      setReportParams(params);
      setPagination({ current: page, pageSize, total: totalCount || 0 });
    } catch (err) {
      console.error('DetailedReport fetch error:', err);
      message.error('Ошибка при загрузке детализированного отчёта');
    } finally {
      preloader();
      setLoading(false);
    }
  }, [startDate, endDate, preloader]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchReportData(1, pagination.pageSize);
  }, [settings]);

  const handleTableChange = (pag) => {
    fetchReportData(pag.current, pag.pageSize);
  };

  const fetchAllItems = useCallback(async () => {
    const token = window.localStorage.getItem('token');
    const res = await axios.get('/api/reports/qualityDetailedReport', {
      params: { token, startDate, endDate },
    });
    if (!res.data?.success) {
      throw new Error(res.data?.error || 'Ошибка загрузки полного набора данных');
    }
    return res.data.data || [];
  }, [startDate, endDate]);

  return (
    ReportParams ? (
      <>
        <TableTitle
          ReportParams={ReportParams}
          name="Детализированный отчет по каждой оценке"
          type="DetailedReport"
          showWeight={showWeight}
          fetchAllItems={fetchAllItems}
        >
          <Checkbox
            checked={showWeight}
            onChange={(e) => setShowWeight(e.target.checked)}
          >
            Показывать числовой эквивалент
          </Checkbox>
        </TableTitle>
        <Table
          dataSource={ReportParams.items}
          columns={TableConfig(questionListData, showWeight).columns}
          scroll={{ x: `${TableConfig(questionListData, showWeight).columns.length * 100}` }}
          loading={loading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
            showTotal: (total) => `Всего: ${total}`,
          }}
          onChange={handleTableChange}
          rowKey={(record, index) => record.id || record.sessionquestion || index}
        />
      </>
    ) : (
      <PreloaderBox>
        <Preloader isOpen small />
      </PreloaderBox>
    )
  );
}

export default DetailedReport;
